import { render, staticRenderFns } from "./NavigationTab.vue?vue&type=template&id=58769a62&scoped=true"
import script from "./NavigationTab.vue?vue&type=script&lang=js"
export * from "./NavigationTab.vue?vue&type=script&lang=js"
import style0 from "./NavigationTab.vue?vue&type=style&index=0&id=58769a62&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58769a62",
  null
  
)

export default component.exports